import React from 'react';
import { Link } from 'react-router-dom';
import { trackEvent } from '../firebaseAnalytics';
import LaunchCta from '../components/LaunchCta';

export default function CTA(){
  return (
    <section className="section" data-bg="purple">
      <div className="container" style={{textAlign:'center'}}>
        <div style={{display:'flex',alignItems:'center',justifyContent:'center',gap:16,margin:'0 0 12px', paddingBottom:16}}>
          <div style={{flex:'1 1 120px',maxWidth:220,height:1,background:'linear-gradient(90deg, rgba(255,255,255,0), rgba(255, 255, 255, 0.2))',borderRadius:2}} />
          <p className="dim" style={{margin:0,fontStyle:'italic'}}>Reach out anytime</p>
          <div style={{flex:'1 1 120px',maxWidth:220,height:1,background:'linear-gradient(90deg, rgba(255,255,255,0.2), rgba(255,255,255,0))',borderRadius:2}} />
        </div>
        <h2 style={{fontSize:'clamp(28px,4vw,44px)',margin:'0 0 10px'}}>Ready to turn <em style={{fontStyle:'italic'}}>chaos</em> into <span style={{color:'#A78BFA',fontWeight:800}}>clarity</span>?</h2>
        <div className="cta-row" style={{marginTop:16}}>
          <Link
            to="/contact"
            className="btn btn-primary"
            onClick={() => trackEvent('contact_click', { source: 'cta_section', destination: 'contact_page' })}
          >
            Contact us ↗
          </Link>
          <LaunchCta
            className="btn btn-primary"
            source="cta_section"
            withArrow
          />
        </div>

        {/* <div style={{marginTop:12, display:'flex', justifyContent:'center', gap:12}}>
          <a className="icon-btn" href="https://instagram.com" target="_blank" rel="noopener" aria-label="Instagram" style={{fontSize:20, width:44, height:44, display:'inline-flex', alignItems:'center', justifyContent:'center'}}>
            <i className="fi fi-brands-instagram" style={{fontSize:20}}></i>
          </a>
          <a className="icon-btn" href="https://x.com" target="_blank" rel="noopener" aria-label="X" style={{fontSize:20, width:44, height:44, display:'inline-flex', alignItems:'center', justifyContent:'center'}}>
            <i className="fi fi-brands-twitter-alt" style={{fontSize:20}}></i>
          </a>
          <a className="icon-btn" href="https://linkedin.com" target="_blank" rel="noopener" aria-label="LinkedIn" style={{fontSize:20, width:44, height:44, display:'inline-flex', alignItems:'center', justifyContent:'center'}}>
            <i className="fi fi-brands-linkedin" style={{fontSize:20}}></i>
          </a>
        </div> */}
      </div>
    </section>
  );
}
